import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'config-document',
    templateUrl: './document.component.html'
})
export class configDocument {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    DocumentName = '';
    DocumentCode = '';
    documentTypeId = '';

    lastModifiedBy = '';
    lastModifiedDate = '';


    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';

    Id = '';
    documentTypes = [];

    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);

        this.PaymentService.GetDocumentTypes()
            .subscribe(departmentListData => {
                this.documentTypes = departmentListData;
            });

        this.PaymentService.GetDocumentList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetDocumentList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.ButtonValue = 'Update';

        this.DocumentName = obj['documentSubType'];
        this.DocumentCode = obj['documentSubTypeCode'];
        this.documentTypeId = obj['documentTypeID'];
        this.createdDate = obj['createdDate'];
        this.CreatedBy = obj['createdBy'];
        this.Id = obj['documentSubTypeId'];
        this.lastModifiedBy = obj["lastModifiedBy"];
        this.lastModifiedDate = obj["lastModifiedDate"];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';

        this.DocumentName = obj['documentSubType'];
        this.DocumentCode = obj['documentSubTypeCode'];
        this.documentTypeId = obj['documentTypeID'];
        this.createdDate = obj['createdDate'];
        this.CreatedBy = obj['createdBy'];
        this.Id = obj['documentSubTypeId'];
        this.lastModifiedBy = obj["lastModifiedBy"];
        this.lastModifiedDate = obj["lastModifiedDate"];
    }

    reset() {
        this.viewMode = false;
        this.IsRecordUpdated = false;
        this.ButtonValue = 'Save';

       
        this.DocumentName = '';
        this.DocumentCode = '';
        this.documentTypeId = '';
        this.createdDate = '';
        this.CreatedBy = '';
        this.Id = '';
        this.lastModifiedBy = '';
        this.lastModifiedDate = '';
    }

    memberFormSubmit() {
        if (this.Id != '') {
            let selectedAreaIds = [];
            let selectedAreaNames = [];
            let data = {
                "documentCode":this.DocumentCode,
                "documentName":this.DocumentName,
                "documentType":this.documentTypeId,
                "id":this.Id,
                "lastModifiedDate":null
            }
            this.PaymentService.EditDepartment(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("something went wrong.");
                    }
                });
        }
        else {

            let data = {
                "createdBy": this.CreatedBy,
                "createdDate": this.createdDate,
                "documentCode": this.DocumentCode,
                "documentName": this.DocumentName,
                "documentType": this.documentTypeId,
                "id": '',
                "lastModifiedBy": '',
                "lastModifiedDate": ''
            }
            this.PaymentService.CreateDocument(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("something went wrong.");
                    }
                });
        }
    }

    deleteProdutConfirm(id, i) {
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {

            "trackingState": this.DeletedIndex
        }
    }
    deleteCancel() {
        this.IsDeleting = false;

        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetDocumentList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    GenerateCode() {
        this.PaymentService.GenerateCode()
            .subscribe(departmentListData => {
                this.DocumentCode = departmentListData;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/configure_document/document.component.ts